var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "animated fadeIn" }, [
    !_vm.person._id
      ? _c("div", [
          _c("p", [
            _vm._v(
              "Person not found, or you do not have access to this person in the given Org/Group context."
            )
          ])
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.person._id
      ? _c(
          "div",
          { staticClass: "personPage" },
          [
            _c(
              "b-row",
              { staticClass: "mb-3", attrs: { "align-h": "between" } },
              [
                _c("b-col", { attrs: { cols: "auto" } }, [
                  _c("p", { staticClass: "card-title mb-0 bold" }, [
                    _vm._v(_vm._s(_vm.friendlyPersonId))
                  ]),
                  _vm._v(" "),
                  _c("p", { staticClass: "small text-muted" }, [
                    _vm._v("Added " + _vm._s(_vm.getPersonAddedDate()))
                  ])
                ]),
                _vm._v(" "),
                _c(
                  "b-col",
                  { attrs: { cols: "auto" } },
                  [
                    _vm.isAllowedToCreateOrEditPerson
                      ? _c(
                          "router-link",
                          {
                            staticClass: "marginR-16",
                            attrs: {
                              to: "/person/" + _vm.friendlyPersonId + "/edit"
                            }
                          },
                          [
                            _c(
                              "b-button",
                              { attrs: { variant: "secondary" } },
                              [_vm._v("Edit")]
                            )
                          ],
                          1
                        )
                      : _c(
                          "b-button",
                          {
                            staticClass: "mx-0",
                            attrs: { disabled: "", variant: "secondary" }
                          },
                          [_vm._v("Edit")]
                        ),
                    _vm._v(" "),
                    _vm.isAllowedToCreateOrEditPerson
                      ? _c(
                          "router-link",
                          {
                            attrs: {
                              to:
                                "/person/" +
                                _vm.friendlyPersonId +
                                "/edit/supplement"
                            }
                          },
                          [
                            _c(
                              "b-button",
                              { attrs: { type: "button", variant: "primary" } },
                              [_vm._v("Supplemental Information")]
                            )
                          ],
                          1
                        )
                      : _c(
                          "b-button",
                          {
                            attrs: {
                              type: "button",
                              disabled: "",
                              variant: "primary"
                            }
                          },
                          [_vm._v("Supplemental Information")]
                        )
                  ],
                  1
                )
              ],
              1
            ),
            _vm._v(" "),
            _c("b-row", { staticStyle: { height: "20px" } }, [_c("b-col")], 1),
            _vm._v(" "),
            _c(
              "b-row",
              [
                _c("b-col", { attrs: { sm: "8" } }, [
                  _c(
                    "div",
                    [
                      _c(
                        "b-card",
                        { attrs: { "no-body": "" } },
                        [
                          _c("b-card-header", [
                            _c("b", [_vm._v("Biographical Information")]),
                            _vm._v(" "),
                            _c(
                              "label",
                              {
                                staticClass:
                                  "switch switch-text infoActiveToggle switch-primary pull-right mb-0 active-toggle"
                              },
                              [
                                _c("input", {
                                  staticClass: "switch-input disabled",
                                  attrs: {
                                    id: "positive_switch",
                                    disabled: !_vm.isAllowedToCreateOrEditPerson,
                                    type: "checkbox"
                                  },
                                  domProps: { checked: !_vm.person.inactive },
                                  on: { change: _vm.toggleActive }
                                }),
                                _vm._v(" "),
                                _c("span", {
                                  staticClass: "switch-label",
                                  attrs: {
                                    "data-on": "Active",
                                    "data-off": "Inactive"
                                  }
                                }),
                                _vm._v(" "),
                                _c("span", { staticClass: "switch-handle" })
                              ]
                            )
                          ]),
                          _vm._v(" "),
                          _c(
                            "b-card-body",
                            [
                              _c(
                                "div",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.showname,
                                      expression: "showname"
                                    }
                                  ]
                                },
                                [
                                  _c("div", { staticClass: "pb-4" }, [
                                    _c(
                                      "small",
                                      {
                                        staticClass:
                                          "mb-0 text-muted text-uppercase font-weight-bold"
                                      },
                                      [_vm._v("Name")]
                                    ),
                                    _vm._v(" "),
                                    _c("br"),
                                    _vm._v(" "),
                                    _c("h4", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.person.b_first_name +
                                            " " +
                                            _vm.person.b_last_name
                                        )
                                      )
                                    ])
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value:
                                            _vm.person.b_nickname ||
                                            _vm.person.p_street_name,
                                          expression:
                                            "person.b_nickname || person.p_street_name"
                                        }
                                      ],
                                      staticClass: "pb-4"
                                    },
                                    [
                                      _c(
                                        "small",
                                        {
                                          staticClass:
                                            "mb-0 text-muted text-uppercase font-weight-bold"
                                        },
                                        [_vm._v("NickName")]
                                      ),
                                      _vm._v(" "),
                                      _c("br"),
                                      _vm._v(" "),
                                      _c("h4", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.person.b_nickname ||
                                              _vm.person.p_street_name
                                          )
                                        )
                                      ])
                                    ]
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "b-button",
                                {
                                  staticClass: "marginB-24",
                                  attrs: { variant: "outline-secondary" },
                                  on: { click: _vm.togglename },
                                  model: {
                                    value: _vm.showname,
                                    callback: function($$v) {
                                      _vm.showname = $$v
                                    },
                                    expression: "showname"
                                  }
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.showname ? "Hide name" : "Show name"
                                    )
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c("div", { staticClass: "pb-4" }, [
                                _c("p", { staticClass: "card-text mb-0" }, [
                                  _c(
                                    "small",
                                    {
                                      staticClass:
                                        "mb-0 text-muted text-uppercase font-weight-bold"
                                    },
                                    [_vm._v("VICTIM INITIALS")]
                                  ),
                                  _vm._v(" "),
                                  _c("br")
                                ]),
                                _vm._v(" "),
                                _c(
                                  "h4",
                                  { staticClass: "mt-0 mb-0 text-uppercase" },
                                  [
                                    _vm._v(
                                      "\n                  " +
                                        _vm._s(
                                          _vm.person.b_first_name[0] +
                                            _vm.person.b_last_name[0]
                                        ) +
                                        "\n                "
                                    )
                                  ]
                                )
                              ]),
                              _vm._v(" "),
                              _vm._l(_vm.getFields("biographical"), function(
                                field,
                                key
                              ) {
                                return _c(
                                  "div",
                                  { key: key, staticClass: "pb-4" },
                                  [
                                    _c("p", { staticClass: "card-text mb-0" }, [
                                      _c(
                                        "small",
                                        {
                                          staticClass:
                                            "mb-0 text-muted text-uppercase font-weight-bold"
                                        },
                                        [_vm._v(_vm._s(field.label))]
                                      ),
                                      _vm._v(" "),
                                      _c("br")
                                    ]),
                                    _vm._v(" "),
                                    _c("h4", { staticClass: "mt-0 mb-0" }, [
                                      _vm._v(
                                        "\n                  " +
                                          _vm._s(_vm.displayFieldData(field)) +
                                          "\n                "
                                      )
                                    ])
                                  ]
                                )
                              })
                            ],
                            2
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-card",
                        { attrs: { "no-body": "" } },
                        [
                          _c("b-card-header", [
                            _c("b", [_vm._v("Victim Information")]),
                            _vm._v(" "),
                            _c(
                              "label",
                              {
                                staticClass:
                                  "switch switch-sm switch-text infoActiveToggle switch-primary mb-0 pull-right"
                              },
                              [
                                _c("input", {
                                  staticClass: "switch-input",
                                  attrs: {
                                    id: "positive_switch",
                                    type: "checkbox"
                                  },
                                  domProps: { checked: _vm.showVictimStatus },
                                  on: { change: _vm.toggleVictimStatus }
                                }),
                                _vm._v(" "),
                                _c("span", {
                                  staticClass: "switch-label",
                                  attrs: { "data-on": "On", "data-off": "Off" }
                                }),
                                _vm._v(" "),
                                _c("span", { staticClass: "switch-handle" })
                              ]
                            )
                          ]),
                          _vm._v(" "),
                          _c(
                            "b-collapse",
                            {
                              attrs: { id: "victiminfosection" },
                              model: {
                                value: _vm.showVictimStatus,
                                callback: function($$v) {
                                  _vm.showVictimStatus = $$v
                                },
                                expression: "showVictimStatus"
                              }
                            },
                            [
                              _c(
                                "b-row",
                                _vm._l(
                                  _vm.getFormattedDataForTraffickingTypes(),
                                  function(field, key) {
                                    return _vm.victimInfo.length
                                      ? _c(
                                          "b-col",
                                          { key: key, attrs: { sm: "6" } },
                                          [
                                            _c(
                                              "b-card-body",
                                              [
                                                _c(
                                                  "p",
                                                  {
                                                    staticClass:
                                                      "card-text mb-0"
                                                  },
                                                  [
                                                    _c(
                                                      "small",
                                                      {
                                                        staticClass:
                                                          "mb-0 text-muted text-uppercase font-weight-bold"
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(field.label)
                                                        )
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c("br")
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "h4",
                                                  { staticClass: "mt-0 mb-0" },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.maybeFormatDate(
                                                          field
                                                        )
                                                      )
                                                    )
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _vm._l(field.value, function(
                                                  item,
                                                  key
                                                ) {
                                                  return _c(
                                                    "div",
                                                    { key: key },
                                                    [
                                                      _c(
                                                        "h4",
                                                        {
                                                          staticClass:
                                                            "mt-0 mb-0"
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              item.startsWith(
                                                                "*"
                                                              )
                                                                ? ""
                                                                : item
                                                            )
                                                          )
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "p",
                                                        {
                                                          staticStyle: {
                                                            "padding-left":
                                                              "20px"
                                                          }
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              item.startsWith(
                                                                "*"
                                                              )
                                                                ? item
                                                                    .split("*")
                                                                    .pop()
                                                                : ""
                                                            )
                                                          )
                                                        ]
                                                      )
                                                    ]
                                                  )
                                                })
                                              ],
                                              2
                                            )
                                          ],
                                          1
                                        )
                                      : _vm._e()
                                  }
                                ),
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-card",
                        { attrs: { "no-body": "" } },
                        [
                          _c("b-card-header", [
                            _c("b", [_vm._v("Services")]),
                            _vm._v(" "),
                            _c(
                              "label",
                              {
                                staticClass:
                                  "switch switch-sm switch-text infoActiveToggle switch-primary mb-0 pull-right"
                              },
                              [
                                _c("input", {
                                  staticClass: "switch-input",
                                  attrs: {
                                    id: "positive_switch",
                                    type: "checkbox"
                                  },
                                  domProps: { checked: _vm.showServices },
                                  on: { change: _vm.toggleServices }
                                }),
                                _vm._v(" "),
                                _c("span", {
                                  staticClass: "switch-label",
                                  attrs: { "data-on": "On", "data-off": "Off" }
                                }),
                                _vm._v(" "),
                                _c("span", { staticClass: "switch-handle" })
                              ]
                            )
                          ]),
                          _vm._v(" "),
                          _c(
                            "b-collapse",
                            {
                              attrs: { id: "servicessection" },
                              model: {
                                value: _vm.showServices,
                                callback: function($$v) {
                                  _vm.showServices = $$v
                                },
                                expression: "showServices"
                              }
                            },
                            [
                              _c(
                                "b-row",
                                _vm._l(_vm.getFields("services"), function(
                                  field,
                                  key
                                ) {
                                  return _c(
                                    "b-col",
                                    { key: key, attrs: { sm: "6" } },
                                    [
                                      _c("b-card-body", [
                                        _c(
                                          "p",
                                          { staticClass: "card-text mb-0" },
                                          [
                                            _c(
                                              "small",
                                              {
                                                staticClass:
                                                  "mb-0 text-muted text-uppercase font-weight-bold"
                                              },
                                              [_vm._v(_vm._s(field.label))]
                                            ),
                                            _vm._v(" "),
                                            _c("br")
                                          ]
                                        ),
                                        _vm._v(" "),
                                        field.label ===
                                        "Services Provided During Program Enrollment"
                                          ? _c(
                                              "div",
                                              _vm._l(
                                                _vm
                                                  .maybeFormatDate(field)
                                                  .split(","),
                                                function(item, key) {
                                                  return _c(
                                                    "div",
                                                    { key: key },
                                                    [
                                                      _c(
                                                        "h4",
                                                        {
                                                          staticClass:
                                                            "mt-0 mb-0"
                                                        },
                                                        [_vm._v(_vm._s(item))]
                                                      )
                                                    ]
                                                  )
                                                }
                                              ),
                                              0
                                            )
                                          : _c("div", [
                                              _c(
                                                "h4",
                                                { staticClass: "mt-0 mb-0" },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.maybeFormatDate(field)
                                                    )
                                                  )
                                                ]
                                              )
                                            ])
                                      ])
                                    ],
                                    1
                                  )
                                }),
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-card",
                        { attrs: { "no-body": "" } },
                        [
                          _c("b-card-header", [
                            _c("b", [_vm._v("Supplemental Information")]),
                            _vm._v(" "),
                            _c(
                              "label",
                              {
                                staticClass:
                                  "switch switch-sm switch-text infoActiveToggle switch-primary mb-0 pull-right"
                              },
                              [
                                _c("input", {
                                  staticClass: "switch-input",
                                  attrs: {
                                    id: "positive_switch",
                                    type: "checkbox"
                                  },
                                  domProps: { checked: _vm.showt1 },
                                  on: { change: _vm.togglet1 }
                                }),
                                _vm._v(" "),
                                _c("span", {
                                  staticClass: "switch-label",
                                  attrs: { "data-on": "On", "data-off": "Off" }
                                }),
                                _vm._v(" "),
                                _c("span", { staticClass: "switch-handle" })
                              ]
                            )
                          ]),
                          _vm._v(" "),
                          _c(
                            "b-collapse",
                            {
                              attrs: { id: "tieronesection" },
                              model: {
                                value: _vm.showt1,
                                callback: function($$v) {
                                  _vm.showt1 = $$v
                                },
                                expression: "showt1"
                              }
                            },
                            [
                              _c(
                                "b-row",
                                [
                                  _vm._l(_vm.getFields("t1p"), function(
                                    field,
                                    key
                                  ) {
                                    return _c(
                                      "b-col",
                                      { key: key, attrs: { sm: "6" } },
                                      [
                                        _c("b-card-body", [
                                          _c(
                                            "p",
                                            { staticClass: "card-text mb-0" },
                                            [
                                              _c(
                                                "small",
                                                {
                                                  staticClass:
                                                    "mb-0 text-muted text-uppercase font-weight-bold"
                                                },
                                                [_vm._v(_vm._s(field.label))]
                                              ),
                                              _vm._v(" "),
                                              _c("br")
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "h4",
                                            { staticClass: "mt-0 mb-0" },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.maybeFormatDate(field)
                                                )
                                              )
                                            ]
                                          )
                                        ])
                                      ],
                                      1
                                    )
                                  }),
                                  _vm._v(" "),
                                  _vm.getFields("t1p_location").length > 0
                                    ? _c(
                                        "b-col",
                                        { attrs: { sm: "6" } },
                                        [
                                          _c(
                                            "b-card-body",
                                            [
                                              _c(
                                                "p",
                                                {
                                                  staticClass: "card-text mb-0"
                                                },
                                                [
                                                  _c(
                                                    "small",
                                                    {
                                                      staticClass:
                                                        "mb-0 text-muted text-uppercase font-weight-bold"
                                                    },
                                                    [
                                                      _vm._v(
                                                        "Last Home Location"
                                                      )
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c("br")
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _vm._l(
                                                _vm.getFields("t1p_location"),
                                                function(field, key) {
                                                  return _c(
                                                    "div",
                                                    { key: key },
                                                    [
                                                      _c(
                                                        "h4",
                                                        {
                                                          staticClass:
                                                            "mt-0 mb-0"
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              field.value
                                                                ? field.value
                                                                : _vm.maybeFormatDate(
                                                                    field
                                                                  )
                                                            )
                                                          )
                                                        ]
                                                      )
                                                    ]
                                                  )
                                                }
                                              )
                                            ],
                                            2
                                          )
                                        ],
                                        1
                                      )
                                    : _vm._e()
                                ],
                                2
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c(
                  "b-col",
                  { attrs: { sm: "4" } },
                  [
                    _c(
                      "b-row",
                      [
                        _c(
                          "b-col",
                          { attrs: { sm: "12" } },
                          [
                            _vm.shouldShowVictimStatusCard
                              ? _c(
                                  "b-card",
                                  {
                                    staticStyle: { border: "none !important" },
                                    attrs: {
                                      "bg-variant": _vm.colorByVictimStatus
                                    }
                                  },
                                  [
                                    _c("p", { staticClass: "bold" }, [
                                      _vm._v("Victim Status")
                                    ]),
                                    _vm._v(" "),
                                    _c("p", { staticClass: "marginB0" }, [
                                      _vm._v(_vm._s(_vm.victimStatus))
                                    ])
                                  ]
                                )
                              : _vm._e()
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-row",
                      [
                        _c(
                          "b-col",
                          { attrs: { sm: "12" } },
                          [
                            _c("SharePersonList", {
                              attrs: {
                                personId: _vm.person._id,
                                personOrganizationOwner:
                                  _vm.person.organizationOwner.id
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-row",
                      [
                        _c(
                          "b-col",
                          { attrs: { sm: "12" } },
                          [
                            _c("ShareCseit", {
                              attrs: {
                                isAllowedToCreateOrEditPerson:
                                  _vm.isAllowedToCreateOrEditPerson,
                                cseits: _vm.cseits,
                                friendlyPersonId: this.friendlyPersonId
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _vm.isUserInLA
                      ? _c(
                          "b-row",
                          [
                            _c(
                              "b-col",
                              { attrs: { sm: "12" } },
                              [
                                _c("ShareLaborScreening", {
                                  attrs: {
                                    isAllowedToCreateOrEditPerson:
                                      _vm.isAllowedToCreateOrEditPerson,
                                    laborScreenings: _vm.laborScreenings,
                                    personId: this.friendlyPersonId
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isUserInLA
                      ? _c(
                          "b-row",
                          [
                            _c(
                              "b-col",
                              { attrs: { sm: "12" } },
                              [
                                _c("TraffickingScreeningCard", {
                                  attrs: {
                                    isAllowedToCreateOrEditPerson:
                                      _vm.isAllowedToCreateOrEditPerson,
                                    oldScreenings: _vm.oldTraffickingScreenings,
                                    screenings: _vm.traffickingScreenings,
                                    person: _vm.person,
                                    personId: this.friendlyPersonId
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "b-row",
                      [
                        _c(
                          "b-col",
                          { attrs: { sm: "12" } },
                          [
                            _c(
                              "b-card",
                              { attrs: { "no-body": "" } },
                              [
                                _c(
                                  "b-card-header",
                                  [
                                    _c("b", [_vm._v("Lighthouse Indicators")]),
                                    _vm._v(" "),
                                    _vm.isAllowedToCreateOrEditPerson
                                      ? _c(
                                          "router-link",
                                          {
                                            attrs: {
                                              to:
                                                "/screening/" +
                                                _vm.friendlyPersonId +
                                                "/add"
                                            }
                                          },
                                          [
                                            _c(
                                              "b-button",
                                              {
                                                staticClass: "headerBtn",
                                                attrs: {
                                                  variant: "outline-primary"
                                                }
                                              },
                                              [_vm._v("Add Indicators")]
                                            )
                                          ],
                                          1
                                        )
                                      : _c(
                                          "b-button",
                                          {
                                            staticClass: "headerBtn",
                                            attrs: {
                                              disabled: "",
                                              variant: "outline-primary"
                                            }
                                          },
                                          [_vm._v("Add Indicators")]
                                        )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _vm._.isArray(_vm.assessments) &&
                                _vm.assessments.length > 0
                                  ? _c(
                                      "div",
                                      _vm._l(_vm.assessments, function(a) {
                                        return _c(
                                          "b-list-group",
                                          { key: a.id, attrs: { flush: "" } },
                                          [
                                            _c(
                                              "router-link",
                                              {
                                                class:
                                                  "concl_" + a.dmst_conclusion,
                                                attrs: {
                                                  to: "/screening/" + a.id
                                                }
                                              },
                                              [
                                                _c("b-list-group-item", [
                                                  _vm._v(
                                                    "\n                      " +
                                                      _vm._s(
                                                        _vm
                                                          .$moment(a.createdAt)
                                                          .format("MM/DD/YYYY")
                                                      ) +
                                                      "\n                      " +
                                                      _vm._s(a.id) +
                                                      "\n                      "
                                                  ),
                                                  a.dmst_conclusion == "Yes"
                                                    ? _c("img", {
                                                        staticClass:
                                                          "icon-danger",
                                                        attrs: {
                                                          src:
                                                            "/static/img/ConcernDanger.png",
                                                          height: "21",
                                                          width: "21"
                                                        }
                                                      })
                                                    : _vm._e(),
                                                  _vm._v(" "),
                                                  _vm.assessmentIsShared(a)
                                                    ? _c("img", {
                                                        attrs: {
                                                          src:
                                                            "/static/img/shareYes.png",
                                                          height: "21",
                                                          width: "21"
                                                        }
                                                      })
                                                    : _vm._e()
                                                ])
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        )
                                      }),
                                      1
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                !_vm._.isArray(_vm.assessments) ||
                                _vm.assessments.length === 0
                                  ? _c(
                                      "b-list-group",
                                      { attrs: { flush: "" } },
                                      [
                                        _c("b-list-group-item", [
                                          _c("p", [
                                            _vm._v(
                                              "No Lighthouse Indicators found"
                                            )
                                          ]),
                                          _vm._v(" "),
                                          _c("p", [
                                            _vm._v(
                                              _vm._s(
                                                _vm._.get(
                                                  _vm.personAssessmentsResponse,
                                                  "body.message",
                                                  ""
                                                )
                                              )
                                            )
                                          ])
                                        ])
                                      ],
                                      1
                                    )
                                  : _vm._e()
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-row",
                      [
                        _c(
                          "b-col",
                          { attrs: { sm: "12" } },
                          [
                            _c(
                              "b-card",
                              { attrs: { "no-body": "" } },
                              [
                                _c(
                                  "b-card-header",
                                  [
                                    _c("b", [_vm._v("Case Notes")]),
                                    _vm._v(" "),
                                    _c(
                                      "b-button",
                                      {
                                        staticClass: "headerBtn",
                                        attrs: {
                                          disabled: !_vm.isAllowedToCreateOrEditPerson,
                                          variant: "outline-primary"
                                        },
                                        on: { click: _vm.addNoteModal }
                                      },
                                      [_vm._v("Add Case Note")]
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _vm._l(_vm.notes, function(note) {
                                  return _c(
                                    "b-list-group",
                                    { key: note.id, attrs: { flush: "" } },
                                    [
                                      _c(
                                        "b-list-group-item",
                                        {
                                          on: {
                                            click: function($event) {
                                              return _vm.viewNoteModal(note)
                                            }
                                          }
                                        },
                                        [
                                          _c(
                                            "a",
                                            {
                                              staticClass: "concl_",
                                              attrs: { href: "" },
                                              on: {
                                                click: function($event) {
                                                  $event.preventDefault()
                                                }
                                              }
                                            },
                                            [
                                              _vm._v(
                                                "\n                    " +
                                                  _vm._s(
                                                    _vm
                                                      .$moment(note.customDate)
                                                      .format("MM/DD/YYYY")
                                                  ) +
                                                  "\n                    " +
                                                  _vm._s(note.title) +
                                                  "\n                    "
                                              ),
                                              _vm.noteIsShared(note)
                                                ? _c("img", {
                                                    attrs: {
                                                      src:
                                                        "/static/img/shareYes.png",
                                                      height: "21",
                                                      width: "21"
                                                    }
                                                  })
                                                : _vm._e()
                                            ]
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                })
                              ],
                              2
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _vm.person.case_notes !== "" &&
                    _vm.person.case_notes !== null
                      ? _c(
                          "b-row",
                          { staticClass: "pt-3" },
                          [
                            _c(
                              "b-col",
                              { attrs: { sm: "12" } },
                              [
                                _c(
                                  "b-card",
                                  { attrs: { "no-body": "" } },
                                  [
                                    _c(
                                      "b-card-header",
                                      [
                                        _c("b", [_vm._v("Case Notes")]),
                                        _vm._v(" "),
                                        _c(
                                          "b-button",
                                          {
                                            staticClass: "headerBtn",
                                            attrs: {
                                              variant: "outline-primary"
                                            },
                                            on: { click: _vm.addNoteModal }
                                          },
                                          [_vm._v("Add Case Note")]
                                        )
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "b-list-group",
                                      [_c("b-list-group-item")],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.addNoteActive
                      ? _c("AddNoteModal", {
                          attrs: { personId: this.personId },
                          on: { modalClose: _vm.closeAddNoteModal }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.viewNoteActive
                      ? _c("ViewNoteModal", {
                          attrs: {
                            isAllowedToCreateOrEditPerson:
                              _vm.isAllowedToCreateOrEditPerson,
                            note: _vm.viewNote
                          },
                          on: { modalClose: _vm.closeViewNoteModal }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "b-row",
                      [
                        _c(
                          "b-col",
                          { attrs: { sm: "12" } },
                          [
                            _c(
                              "b-card",
                              { attrs: { "no-body": "" } },
                              [
                                _c(
                                  "b-card-header",
                                  [
                                    _c("b", [_vm._v("Advocates")]),
                                    _vm._v(" "),
                                    _c(
                                      "b-button",
                                      {
                                        staticClass: "headerBtn",
                                        attrs: {
                                          disabled: !_vm.isAllowedToCreateOrEditPerson,
                                          variant: "outline-primary"
                                        },
                                        on: { click: _vm.addAdvocateModal }
                                      },
                                      [_vm._v("Add Advocate")]
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _vm._l(
                                  _vm.getAdvocatesInOrder(_vm.advocates),
                                  function(advocate) {
                                    return _c(
                                      "b-list-group",
                                      {
                                        key: advocate.id,
                                        attrs: { flush: "" }
                                      },
                                      [
                                        _c(
                                          "b-list-group-item",
                                          {
                                            on: {
                                              click: function($event) {
                                                return _vm.viewAdvocateModal(
                                                  advocate
                                                )
                                              }
                                            }
                                          },
                                          [
                                            _c(
                                              "a",
                                              {
                                                staticClass: "concl_",
                                                attrs: { href: "" },
                                                on: {
                                                  click: function($event) {
                                                    $event.preventDefault()
                                                  }
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  "\n                    " +
                                                    _vm._s(advocate.name) +
                                                    "\n                    "
                                                ),
                                                _c("img", {
                                                  attrs: {
                                                    height: "21",
                                                    width: "21",
                                                    src:
                                                      "static/img/" +
                                                      (!advocate.active
                                                        ? "Inactive.png"
                                                        : "ManagerYes.png")
                                                  }
                                                }),
                                                _vm._v(" "),
                                                _vm.advocateIsShared(advocate)
                                                  ? _c("img", {
                                                      attrs: {
                                                        src:
                                                          "/static/img/shareYes.png",
                                                        height: "21",
                                                        width: "21"
                                                      }
                                                    })
                                                  : _vm._e()
                                              ]
                                            )
                                          ]
                                        )
                                      ],
                                      1
                                    )
                                  }
                                )
                              ],
                              2
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _vm.addAdvocateActive
                      ? _c("AddAdvocateModal", {
                          attrs: {
                            person: _vm.person,
                            personId: this.personId
                          },
                          on: { modalClose: _vm.closeAddAdvocateModal }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.viewAdvocateActive
                      ? _c("ViewAdvocateModal", {
                          attrs: {
                            isAllowedToCreateOrEditPerson:
                              _vm.isAllowedToCreateOrEditPerson,
                            viewAdvocate: this.viewAdvocate,
                            person: _vm.person,
                            personId: this.personId
                          },
                          on: { modalClose: _vm.closeViewAdvocateModal }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "b-row",
                      [
                        _c(
                          "b-col",
                          { attrs: { sm: "12" } },
                          [
                            _c("PersonExternalIds", {
                              attrs: {
                                isAllowedToCreateOrEditPerson:
                                  _vm.isAllowedToCreateOrEditPerson,
                                personId: _vm.person._id
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-row",
                      [
                        _c(
                          "b-col",
                          { attrs: { sm: "12" } },
                          [
                            _c(
                              "b-card",
                              { attrs: { "no-body": "" } },
                              [
                                _c("b-card-header", [
                                  _c("b", [_vm._v("Meta")])
                                ]),
                                _vm._v(" "),
                                _c(
                                  "b-list-group",
                                  { attrs: { flush: "" } },
                                  [
                                    _c(
                                      "b-list-group-item",
                                      { staticClass: "small text-muted" },
                                      [
                                        _c("b", [_vm._v("Created At: ")]),
                                        _vm._v(
                                          " " +
                                            _vm._s(_vm.getCreatedAt()) +
                                            "\n                  "
                                        ),
                                        _vm._.isObject(_vm.person.createdBy)
                                          ? _c("div", [
                                              _c("b", [_vm._v(" by: ")]),
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm._.get(
                                                      _vm.person,
                                                      "createdBy.emailAddress",
                                                      ""
                                                    )
                                                  ) +
                                                  "\n                  "
                                              )
                                            ])
                                          : _vm._e()
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "b-list-group-item",
                                      { staticClass: "small text-muted" },
                                      [
                                        _c("b", [_vm._v("Last Updated: ")]),
                                        _vm._v(
                                          " " +
                                            _vm._s(_vm.getLastUpdateDate()) +
                                            "\n                  "
                                        ),
                                        _vm._.isObject(_vm.person.updatedBy)
                                          ? _c("div", [
                                              _c("b", [_vm._v(" by: ")]),
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm._.get(
                                                      _vm.person,
                                                      "updatedBy.emailAddress",
                                                      ""
                                                    )
                                                  ) +
                                                  "\n                  "
                                              )
                                            ])
                                          : _vm._e()
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "b-list-group-item",
                                      { staticClass: "small text-muted" },
                                      [
                                        _c("b", [
                                          _vm._v("Current Record Owner: ")
                                        ]),
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm._.get(
                                                _vm.person,
                                                "organizationOwner.title"
                                              )
                                            ) +
                                            "\n                "
                                        )
                                      ]
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-c32c7146", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c32c7146","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/t1/Person.vue
// module id = 1638
// module chunks = 0